import * as React from "react";
import {VeboxModels} from "../../types/veboxModels";
import {getRoleFromRoleCode, RoleListElement} from "../../components/Utils/RolesUtils";
import {useCommonData} from "../contexts/CommonDataProvider";
import {VeboxSelectionList} from "../../components/selection_list/VeboxSelectionList";

interface NotAvailableRolesListProps {
    roleCodes: string[]
}

const createRolesFromCodes = (roleCodes: string[], visibleRoles: VeboxModels.Role[]): VeboxModels.Role[] => {
    return roleCodes.map(roleCode => getRoleFromRoleCode(roleCode, visibleRoles))
}
export const NotAvailableRolesList: React.FC<NotAvailableRolesListProps> = ({roleCodes}) => {
    const {roles: visibleRoles} = useCommonData();
    const mappedRoles: VeboxModels.Role[] = createRolesFromCodes(roleCodes, visibleRoles)

    return <div className={"users-management-list-container"} style={{height: "150px", marginTop: "15px"}}>
        <VeboxSelectionList
            className={"selection-list users-management-list"}
        >
            {mappedRoles.map(role => <RoleListElement role={role} key={role.code}/>)}
        </VeboxSelectionList>
    </div>
}